import { animationTransition } from '@joykit/variables';

export namespace animations {
  export const modal = {
    entering: {
      opacity: 1,
      transform: 'translateZ(.01px) scale(1.1)',
      transition: animationTransition('opacity', 'transform')
    },
    entered: {
      opacity: 1,
      transition: animationTransition('opacity', 'transform'),

      transform: 'scale(1)'
    },
    exiting: {
      opacity: 0,
      transition: animationTransition('opacity', 'transform'),
      transform: 'translateZ(.01px) scale(.9)'
    }
  };
}
